import React from "react";
import { Button, Tooltip } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const viewButtonSx = {
  minWidth: 84,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderRadius: 1.5,
  px: 1.25,
  py: 0.35,
  lineHeight: 1.4,
  boxShadow: "none",
  "&:hover": {
    boxShadow: 1,
  },
};

export default function SuperAdminViewAction({ onClick, label = "View", disabled = false }) {
  return (
    <Tooltip title={label}>
      <span>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 18 }} />}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
          disabled={disabled}
          sx={viewButtonSx}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
